import { gql, useLazyQuery } from "@apollo/client";
import {
  ListGoodOptionQuery,
  ListGoodOptionQueryVariables,
} from "../gql/graphql";

const LIST_GOOD_OPTION_QUERY = gql`
  query listGoodOption($input: ListGoodOptionInput!) {
    listGoodOption(input: $input) {
      ok
      err
      goodOptions {
        id
        createdAt
        name
        price
        isActive
        discountRate
        deliveryDate
        desc
        corporation {
          id
          name
        }
        good {
          id
          subCategory {
            id
            name
          }
          price
          status
          discountRate
          title
          summary

          corporation {
            id
            name
          }
          goodPosters {
            id
            upload {
              url
            }
          }
        }
      }
    }
  }
`;

export const useListGoodOption = (
  onCompleted?: (data: ListGoodOptionQuery) => void
) => {
  return useLazyQuery<ListGoodOptionQuery, ListGoodOptionQueryVariables>(
    LIST_GOOD_OPTION_QUERY,
    {
      onCompleted,
      fetchPolicy: "network-only",
    }
  );
};
